import {httpService} from "@/modules/common/services";
import {frontageApiService} from "@/plugins/frontage-api";

const createZoomIntegration = (code) => {
  return httpService.post("integrations/zoom/connect", {code: code})
}

const authorize = async () => {
  const appConfig = window.app_config
  return new Promise(async (resolve) => {
    const zoomUrl = `http://zoom.us/oauth/authorize?response_type=code&client_id=${appConfig.zoomClientId}&redirect_uri=${appConfig.zoomRedirectUri}`
    const popupWindow = window.open(zoomUrl, 'popup', 'width=1024,height=700,resizable=1,toolbar=0,location=0,status=0,top=100,left=100,scrollbars=yes')
    let result

    const timer = setInterval(() => {
      if (popupWindow.closed) {
        clearInterval(timer);
        if (!result && !result.authorized) {
          resolve('window-closed')
        }
      }
    }, 1000);

    const popupListenerFunc = async (e) => {
      window.removeEventListener('zoom_integration', popupListenerFunc)
      result = await createZoomIntegration(e.detail.code)
      if (!popupWindow.closed) {
        popupWindow.close()
      }
      await frontageApiService.get('reload-account')
      result.authorized = true
      resolve(result)
    }

    window.addEventListener('zoom_integration', popupListenerFunc)
    window.addEventListener('message', (e) => {
      if (e.data.name === 'zoom_integration_success') {
        popupListenerFunc(e.data)
      }
    })
  })
}

const disconnect = async () => {
  return new Promise(async (resolve) => {
    await httpService.remove('integrations/zoom/me')
    await frontageApiService.get('reload-account')
    resolve()
  })
}

const getConnectedDetails = async () => (await httpService.get('integrations/zoom/connection_details')).data


export const zoomService = {
  authorize,
  disconnect,
  getConnectedDetails
}
